module.exports = __webpack_public_path__ + "static/media/bag.9f9b2266.svg";